"use client";
import React, { useState } from "react";
import SearchIcon from "../icons/SearchIcon";
import { useTranslations } from "next-intl";
import { useSearchParams } from "next/navigation";

function SearchInput({
  color = "#F26716",
  onChange,
  ...props
}: InputPropsType) {
  const t = useTranslations("Index");
  const searchParams = useSearchParams();
  const [value, setValue] = useState(searchParams.get("search") || "");

  return (
    <div
      style={{ borderColor: color }}
      className="w-full items-center lg:pe-[0.31rem] pe-[4px]  
    lg:h-[4.12rem] h-[36px]  border-[#F26716] border-[1px] rounded-[32px] flex"
    >
      <input
        value={value}
        placeholder={t("searchPlaceholder")}
        className="font-medium text-[#A8A5A5] lg:px-[1.875rem] px-[20px] flex-1 border-none  bg-transparent border-0 h-full focus:border-none focus:outline-none text-[12px] lg:text-[1.25rem]"
        {...props}
        onChange={(e) => {
          setValue(e.target.value);
          if (onChange) onChange(e);
        }}
      ></input>
      <div
        style={{ background: color }}
        className="ms-auto rounded-full lg:w-[3.52rem] w-[29px]  lg:h-[3.52rem] flex justify-center items-center h-[29px] bg-[#F26716] "
      >
        <SearchIcon className="lg:w-[1.56rem] lg:h-[1.56rem]  w-[13.2px] h-[13.2px] " />
      </div>
    </div>
  );
}

export default SearchInput;
type InputPropsType = React.InputHTMLAttributes<HTMLInputElement> & {
  color?: string;
};
